import { AbstractControl, ValidatorFn } from '@angular/forms'

export function postalCodeValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {

        const value = control.value;
        if (value === null || value === '') {
            return null;
        }

        if (value && value.match(/^[0-9]{4}$/)) {
            return null;
        }
        else {
            return { 'invalidPostalCode': true };
        }
    }
}

